import { Button } from 'antd';
import { useNavigate, useRouteError } from 'react-router-dom';
import buildErrorView from './buildErrorView';

const ErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const { status, message } = buildErrorView(error);

  const handleHomeClick = () => {
    void navigate('/');
  };

  return (
    <div>
      <h1>Error</h1>
      {message !== undefined && <p>{message}</p>}
      {status !== undefined && <p>HTTP {status}</p>}
      <Button type='primary' onClick={handleHomeClick}>
        ホームに戻る
      </Button>
    </div>
  );
};

export default ErrorBoundary;
